module.exports = __webpack_public_path__ + "f9324d5fd9f50b2e8c7dd987650b924c.svg";